module.exports = __webpack_public_path__ + "assets/img/wallpaper-brighter-uncompressed.8ebbaa44.png";